import { useState } from 'react';
import { Button } from '@photocarbone/nooco-ui';
import { NavigationTabsProps, PROJECT_SIMULATOR_TABS } from './utils';
import { useTranslation } from 'react-i18next';
import SummaryModal from './Summary/SummaryModal';
import { usePatchProjectSimulator } from '../../../hooks/useQuery/projectSimulator';

function NavigationButtons({
  currentTab,
  handleNavigation,
  form,
  formValues,
  shouldPatchForm,
  areAllMaterialsCompleted,
}: NavigationTabsProps) {
  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState(false);
  const { mutate, isLoading } = usePatchProjectSimulator();

  switch (currentTab) {
    case PROJECT_SIMULATOR_TABS.QUICK_SIMULATION:
      return (
        <div
          className="button-container"
          style={{
            alignSelf: 'flex-end',
          }}
        >
          <Button
            loading={isLoading}
            key={`${PROJECT_SIMULATOR_TABS.QUICK_SIMULATION}_NEXT_BUTTON`}
            className="purple-button"
            text={t('APP.PROJECT.SIMULATOR.BUTTON.NEXT', {
              defaultValue: 'Suivant',
            })}
            onClick={async () => {
              const isValid = await form.trigger();
              isValid &&
                handleNavigation(PROJECT_SIMULATOR_TABS.ADVANCED_CONCEPTION);
            }}
          />
        </div>
      );
    case PROJECT_SIMULATOR_TABS.ADVANCED_CONCEPTION:
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <Button
            key={`${PROJECT_SIMULATOR_TABS.ADVANCED_CONCEPTION}_PREVIOUS_BUTTON`}
            className="close-button"
            text={t('APP.PROJECT.SIMULATOR.BUTTON.PREVIOUS', {
              defaultValue: 'Retour',
            })}
            onClick={() => handleNavigation(PROJECT_SIMULATOR_TABS.QUICK_SIMULATION)}
          />

          <Button
            key={`${PROJECT_SIMULATOR_TABS.ADVANCED_CONCEPTION}_NEXT_BUTTON`}
            className="purple-button"
            text={t('APP.PROJECT.SIMULATOR.BUTTON.NEXT', {
              defaultValue: 'Suivant',
            })}
            onClick={async () => {
              const isValid = await form.trigger();
              if (isValid && areAllMaterialsCompleted && !shouldPatchForm) {
                handleNavigation(PROJECT_SIMULATOR_TABS.SUMMARY);
              }
              if (isValid && areAllMaterialsCompleted && shouldPatchForm) {
                mutate(formValues, {
                  onSuccess: () => handleNavigation(PROJECT_SIMULATOR_TABS.SUMMARY),
                });
              }
            }}
            loading={isLoading}
          />
        </div>
      );
    case PROJECT_SIMULATOR_TABS.SUMMARY:
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <Button
            key={`${PROJECT_SIMULATOR_TABS.SUMMARY}_PREVIOUS_BUTTON`}
            className="close-button"
            text={t('APP.PROJECT.SIMULATOR.BUTTON.PREVIOUS', {
              defaultValue: 'Retour',
            })}
            onClick={() =>
              handleNavigation(PROJECT_SIMULATOR_TABS.ADVANCED_CONCEPTION)
            }
          />

          <Button
            className="purple-button"
            text={t('APP.PROJECT.SIMULATOR.BUTTON.PROJECT.CREATION', {
              defaultValue: 'Créer un projet à partir de cette simulation',
            })}
            onClick={() => setOpenModal(true)}
          />
          <SummaryModal openModal={openModal} setOpenModal={setOpenModal} />
        </div>
      );
  }
}

export default NavigationButtons;
